import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { StaticDataProfileImpl } from "../model/impl/StaticDataProfileImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class StaticDataProfileImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: StaticDataProfileImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.accounts != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(1),
        false,
        encodable.accounts,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.allSalesGroups != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(2),
        false,
        encodable.allSalesGroups,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.allTradingGroups != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(3),
        false,
        encodable.allTradingGroups,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.clients != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(4),
        false,
        encodable.clients,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.currencyPairs != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(5),
        false,
        encodable.currencyPairs,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.currencys != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(6),
        false,
        encodable.currencys,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.fixingSources != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(7),
        false,
        encodable.fixingSources,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.salesGroups != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(8),
        false,
        encodable.salesGroups,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.slSlippageConstants != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(9),
        false,
        encodable.slSlippageConstants,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.tradingGroups != null) {
      this.baseEncoder.writeStartFid(10, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(10),
        false,
        encodable.tradingGroups,
        streamout,
      );
      this.baseEncoder.writeEndFid(10, streamout);
    }
    /*Object encoding*/
    if (encodable.user != null) {
      this.baseEncoder.writeStartFid(11, streamout);
      this.baseEncoder.writeObject(
        false,
        StaticDataProfileImplEncoder.fidTypeMap.get(11),
        true,
        encodable.user,
        streamout,
      );
      this.baseEncoder.writeEndFid(11, streamout);
    }
    /*Object encoding*/
    if (encodable.updateMask != null) {
      this.baseEncoder.writeStartFid(12, streamout);
      this.baseEncoder.writeObject(
        false,
        StaticDataProfileImplEncoder.fidTypeMap.get(12),
        false,
        encodable.updateMask,
        streamout,
      );
      this.baseEncoder.writeEndFid(12, streamout);
    }
    /*Object encoding*/
    if (encodable.blotterFilters != null) {
      this.baseEncoder.writeStartFid(13, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(13),
        false,
        encodable.blotterFilters,
        streamout,
      );
      this.baseEncoder.writeEndFid(13, streamout);
    }
    /*Object encoding*/
    if (encodable.profileSettings != null) {
      this.baseEncoder.writeStartFid(14, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(14),
        false,
        encodable.profileSettings,
        streamout,
      );
      this.baseEncoder.writeEndFid(14, streamout);
    }
    /*Object encoding*/
    if (encodable.systemSettings != null) {
      this.baseEncoder.writeStartFid(15, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(15),
        false,
        encodable.systemSettings,
        streamout,
      );
      this.baseEncoder.writeEndFid(15, streamout);
    }
    /*Object encoding*/
    if (encodable.userRoles != null) {
      this.baseEncoder.writeStartFid(16, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(16),
        false,
        encodable.userRoles,
        streamout,
      );
      this.baseEncoder.writeEndFid(16, streamout);
    }
    /*Object encoding*/
    if (encodable.users != null) {
      this.baseEncoder.writeStartFid(17, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(17),
        false,
        encodable.users,
        streamout,
      );
      this.baseEncoder.writeEndFid(17, streamout);
    }
    /*Object encoding*/
    if (encodable.rateSources != null) {
      this.baseEncoder.writeStartFid(18, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(18),
        false,
        encodable.rateSources,
        streamout,
      );
      this.baseEncoder.writeEndFid(18, streamout);
    }
    /*Object encoding*/
    if (encodable.currencyPairGroups != null) {
      this.baseEncoder.writeStartFid(19, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(19),
        false,
        encodable.currencyPairGroups,
        streamout,
      );
      this.baseEncoder.writeEndFid(19, streamout);
    }
    /*Object encoding*/
    if (encodable.environmentTag != null) {
      this.baseEncoder.writeStartFid(20, streamout);
      this.baseEncoder.writeObject(
        false,
        StaticDataProfileImplEncoder.fidTypeMap.get(20),
        false,
        encodable.environmentTag,
        streamout,
      );
      this.baseEncoder.writeEndFid(20, streamout);
    }
    /*Object encoding*/
    if (encodable.tradingChannelProfiles != null) {
      this.baseEncoder.writeStartFid(21, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(21),
        false,
        encodable.tradingChannelProfiles,
        streamout,
      );
      this.baseEncoder.writeEndFid(21, streamout);
    }
    /*Object encoding*/
    if (encodable.branches != null) {
      this.baseEncoder.writeStartFid(22, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(22),
        false,
        encodable.branches,
        streamout,
      );
      this.baseEncoder.writeEndFid(22, streamout);
    }
    /*Object encoding*/
    if (encodable.defaultPositionBook != null) {
      this.baseEncoder.writeStartFid(23, streamout);
      this.baseEncoder.writeObject(
        false,
        StaticDataProfileImplEncoder.fidTypeMap.get(23),
        true,
        encodable.defaultPositionBook,
        streamout,
      );
      this.baseEncoder.writeEndFid(23, streamout);
    }
    /*Object encoding*/
    if (encodable.timeZones != null) {
      this.baseEncoder.writeStartFid(24, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(24),
        false,
        encodable.timeZones,
        streamout,
      );
      this.baseEncoder.writeEndFid(24, streamout);
    }
    /*Object encoding*/
    if (encodable.marketTimeConstants != null) {
      this.baseEncoder.writeStartFid(25, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(25),
        false,
        encodable.marketTimeConstants,
        streamout,
      );
      this.baseEncoder.writeEndFid(25, streamout);
    }
    /*Object encoding*/
    if (encodable.clientContacts != null) {
      this.baseEncoder.writeStartFid(26, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(26),
        false,
        encodable.clientContacts,
        streamout,
      );
      this.baseEncoder.writeEndFid(26, streamout);
    }
    /*Object encoding*/
    if (encodable.offlineSystemControls != null) {
      this.baseEncoder.writeStartFid(27, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(27),
        false,
        encodable.offlineSystemControls,
        streamout,
      );
      this.baseEncoder.writeEndFid(27, streamout);
    }
    /*Object encoding*/
    if (encodable.userVisibilityProfile != null) {
      this.baseEncoder.writeStartFid(28, streamout);
      this.baseEncoder.writeObject(
        false,
        StaticDataProfileImplEncoder.fidTypeMap.get(28),
        true,
        encodable.userVisibilityProfile,
        streamout,
      );
      this.baseEncoder.writeEndFid(28, streamout);
    }
    /*Object encoding*/
    if (encodable.tradableClientCodes != null) {
      this.baseEncoder.writeStartFid(29, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(29),
        false,
        encodable.tradableClientCodes,
        streamout,
      );
      this.baseEncoder.writeEndFid(29, streamout);
    }
    /*Object encoding*/
    if (encodable.tradableAccountCodes != null) {
      this.baseEncoder.writeStartFid(30, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(30),
        false,
        encodable.tradableAccountCodes,
        streamout,
      );
      this.baseEncoder.writeEndFid(30, streamout);
    }
    /*Object encoding*/
    if (encodable.algoStrategies != null) {
      this.baseEncoder.writeStartFid(31, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(31),
        false,
        encodable.algoStrategies,
        streamout,
      );
      this.baseEncoder.writeEndFid(31, streamout);
    }
    /*Object encoding*/
    if (encodable.systemVersion != null) {
      this.baseEncoder.writeStartFid(32, streamout);
      this.baseEncoder.writeObject(
        false,
        StaticDataProfileImplEncoder.fidTypeMap.get(32),
        false,
        encodable.systemVersion,
        streamout,
      );
      this.baseEncoder.writeEndFid(32, streamout);
    }
    /*Object encoding*/
    if (encodable.customFieldDefinitions != null) {
      this.baseEncoder.writeStartFid(33, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(33),
        false,
        encodable.customFieldDefinitions,
        streamout,
      );
      this.baseEncoder.writeEndFid(33, streamout);
    }
    /*Object encoding*/
    if (encodable.benchmarkFixings != null) {
      this.baseEncoder.writeStartFid(34, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(34),
        false,
        encodable.benchmarkFixings,
        streamout,
      );
      this.baseEncoder.writeEndFid(34, streamout);
    }
    /*Object encoding*/
    if (encodable.algoHedgeConfigInfos != null) {
      this.baseEncoder.writeStartFid(35, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(35),
        false,
        encodable.algoHedgeConfigInfos,
        streamout,
      );
      this.baseEncoder.writeEndFid(35, streamout);
    }
    /*Object encoding*/
    if (encodable.tradableBranches != null) {
      this.baseEncoder.writeStartFid(36, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(36),
        false,
        encodable.tradableBranches,
        streamout,
      );
      this.baseEncoder.writeEndFid(36, streamout);
    }
    /*Object encoding*/
    if (encodable.systemTradeDateRoll != null) {
      this.baseEncoder.writeStartFid(37, streamout);
      this.baseEncoder.writeObject(
        false,
        StaticDataProfileImplEncoder.fidTypeMap.get(37),
        false,
        encodable.systemTradeDateRoll,
        streamout,
      );
      this.baseEncoder.writeEndFid(37, streamout);
    }
    /*Object encoding*/
    if (encodable.requestOrderTypeStrategies != null) {
      this.baseEncoder.writeStartFid(38, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(38),
        false,
        encodable.requestOrderTypeStrategies,
        streamout,
      );
      this.baseEncoder.writeEndFid(38, streamout);
    }
    /*Object encoding*/
    if (encodable.tradableAlgos != null) {
      this.baseEncoder.writeStartFid(39, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(39),
        false,
        encodable.tradableAlgos,
        streamout,
      );
      this.baseEncoder.writeEndFid(39, streamout);
    }
    /*Object encoding*/
    if (encodable.autoHedgingStatus != null) {
      this.baseEncoder.writeStartFid(40, streamout);
      this.baseEncoder.writeObject(
        false,
        StaticDataProfileImplEncoder.fidTypeMap.get(40),
        true,
        encodable.autoHedgingStatus,
        streamout,
      );
      this.baseEncoder.writeEndFid(40, streamout);
    }
    /*Object encoding*/
    if (encodable.platformProfiles != null) {
      this.baseEncoder.writeStartFid(41, streamout);
      this.baseEncoder.writeObject(
        true,
        StaticDataProfileImplEncoder.fidTypeMap.get(41),
        false,
        encodable.platformProfiles,
        streamout,
      );
      this.baseEncoder.writeEndFid(41, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        StaticDataProfileImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,StaticDataProfileImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "com.bcdfx.model.Account"],
    [2, "com.bcdfx.model.SalesGroup"],
    [3, "com.bcdfx.model.TradingGroup"],
    [4, "com.bcdfx.model.Client"],
    [5, "com.bcdfx.model.CurrencyPair"],
    [6, "com.bcdfx.model.Currency"],
    [7, "com.bcdfx.model.NdfSource"],
    [8, "java.lang.Long"],
    [9, "java.lang.String"],
    [10, "java.lang.Long"],
    [11, "com.bcdfx.model.User"],
    [12, "java.lang.Long"],
    [13, "com.bcdfx.servicerequest.dataprofile.DataProfileDescriptor"],
    [14, "com.bcdfx.model.ProfileSetting"],
    [15, "com.bcdfx.model.SystemSetting"],
    [16, "java.lang.String"],
    [17, "com.bcdfx.model.User"],
    [18, "com.bcdfx.model.RateSource"],
    [19, "com.bcdfx.model.CurrencyPairGroup"],
    [20, "java.lang.String"],
    [21, "com.bcdfx.model.TradingChannelProfile"],
    [22, "com.bcdfx.model.Branch"],
    [23, "com.bcdfx.model.PositionBook"],
    [24, "com.bcdfx.model.calendar.TimeZone"],
    [25, "com.bcdfx.model.MarketTimeConstant"],
    [26, "com.bcdfx.model.ClientContact"],
    [27, "com.bcdfx.model.SystemControl"],
    [28, "com.bcdfx.model.UserVisibilityProfile"],
    [29, "java.lang.String"],
    [30, "java.lang.String"],
    [31, "com.bcdfx.model.AlgoStrategy"],
    [32, "java.lang.String"],
    [33, "com.bcdfx.model.CustomField"],
    [34, "com.bcdfx.model.BenchmarkFixing"],
    [35, "com.bcdfx.model.AlgoHedgeConfigInfo"],
    [36, "java.lang.String"],
    [37, "java.util.Date"],
    [38, "com.bcdfx.model.PlRequestOrderTypeStrategy"],
    [39, "java.lang.String"],
    [40, "com.bcdfx.model.AutoHedgingStatus"],
    [41, "com.bcdfx.model.PlatformProfile"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: StaticDataProfileImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: Array<CubiqTS.Account> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.accounts = <Array<CubiqTS.Account>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: Array<CubiqTS.SalesGroup> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.allSalesGroups = <Array<CubiqTS.SalesGroup>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: Array<CubiqTS.TradingGroup> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.allTradingGroups = <Array<CubiqTS.TradingGroup>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: Array<CubiqTS.Client> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.clients = <Array<CubiqTS.Client>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: Array<CubiqTS.CurrencyPair> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.currencyPairs = <Array<CubiqTS.CurrencyPair>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: Array<CubiqTS.Currency> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.currencys = <Array<CubiqTS.Currency>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: Array<CubiqTS.NdfSource> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.fixingSources = <Array<CubiqTS.NdfSource>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: Array<CubiqTS.Long> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.salesGroups = <Array<CubiqTS.Long>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: Array<string> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.slSlippageConstants = <Array<string>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10: {
          /*Object encoding*/
          let val: Array<CubiqTS.Long> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(10),
            streamin,
          );
          encodable.tradingGroups = <Array<CubiqTS.Long>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 11: {
          /*Object encoding*/
          let val: CubiqTS.User = this.baseEncoder.readObject(
            true,
            false,
            StaticDataProfileImplEncoder.fidTypeMap.get(11),
            streamin,
          );
          encodable.user = <CubiqTS.User>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 12: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            StaticDataProfileImplEncoder.fidTypeMap.get(12),
            streamin,
          );
          encodable.updateMask = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 13: {
          /*Object encoding*/
          let val: Array<CubiqTS.DataProfileDescriptor> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(13),
            streamin,
          );
          encodable.blotterFilters = <Array<CubiqTS.DataProfileDescriptor>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 14: {
          /*Object encoding*/
          let val: Array<CubiqTS.ProfileSetting> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(14),
            streamin,
          );
          encodable.profileSettings = <Array<CubiqTS.ProfileSetting>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 15: {
          /*Object encoding*/
          let val: Array<CubiqTS.SystemSetting> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(15),
            streamin,
          );
          encodable.systemSettings = <Array<CubiqTS.SystemSetting>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 16: {
          /*Object encoding*/
          let val: Array<string> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(16),
            streamin,
          );
          encodable.userRoles = <Array<string>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 17: {
          /*Object encoding*/
          let val: Array<CubiqTS.User> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(17),
            streamin,
          );
          encodable.users = <Array<CubiqTS.User>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 18: {
          /*Object encoding*/
          let val: Array<CubiqTS.RateSource> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(18),
            streamin,
          );
          encodable.rateSources = <Array<CubiqTS.RateSource>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 19: {
          /*Object encoding*/
          let val: Array<CubiqTS.CurrencyPairGroup> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(19),
            streamin,
          );
          encodable.currencyPairGroups = <Array<CubiqTS.CurrencyPairGroup>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 20: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            StaticDataProfileImplEncoder.fidTypeMap.get(20),
            streamin,
          );
          encodable.environmentTag = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 21: {
          /*Object encoding*/
          let val: Array<CubiqTS.TradingChannelProfile> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(21),
            streamin,
          );
          encodable.tradingChannelProfiles = <Array<CubiqTS.TradingChannelProfile>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 22: {
          /*Object encoding*/
          let val: Array<CubiqTS.Branch> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(22),
            streamin,
          );
          encodable.branches = <Array<CubiqTS.Branch>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 23: {
          /*Object encoding*/
          let val: CubiqTS.PositionBook = this.baseEncoder.readObject(
            true,
            false,
            StaticDataProfileImplEncoder.fidTypeMap.get(23),
            streamin,
          );
          encodable.defaultPositionBook = <CubiqTS.PositionBook>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 24: {
          /*Object encoding*/
          let val: Array<CubiqTS.TimeZone> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(24),
            streamin,
          );
          encodable.timeZones = <Array<CubiqTS.TimeZone>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 25: {
          /*Object encoding*/
          let val: Array<CubiqTS.MarketTimeConstant> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(25),
            streamin,
          );
          encodable.marketTimeConstants = <Array<CubiqTS.MarketTimeConstant>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 26: {
          /*Object encoding*/
          let val: Array<CubiqTS.ClientContact> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(26),
            streamin,
          );
          encodable.clientContacts = <Array<CubiqTS.ClientContact>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 27: {
          /*Object encoding*/
          let val: Array<CubiqTS.SystemControl> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(27),
            streamin,
          );
          encodable.offlineSystemControls = <Array<CubiqTS.SystemControl>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 28: {
          /*Object encoding*/
          let val: CubiqTS.UserVisibilityProfile = this.baseEncoder.readObject(
            true,
            false,
            StaticDataProfileImplEncoder.fidTypeMap.get(28),
            streamin,
          );
          encodable.userVisibilityProfile = <CubiqTS.UserVisibilityProfile>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 29: {
          /*Object encoding*/
          let val: Array<string> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(29),
            streamin,
          );
          encodable.tradableClientCodes = <Array<string>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 30: {
          /*Object encoding*/
          let val: Array<string> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(30),
            streamin,
          );
          encodable.tradableAccountCodes = <Array<string>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 31: {
          /*Object encoding*/
          let val: Array<CubiqTS.AlgoStrategy> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(31),
            streamin,
          );
          encodable.algoStrategies = <Array<CubiqTS.AlgoStrategy>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 32: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            StaticDataProfileImplEncoder.fidTypeMap.get(32),
            streamin,
          );
          encodable.systemVersion = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 33: {
          /*Object encoding*/
          let val: Array<CubiqTS.CustomField> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(33),
            streamin,
          );
          encodable.customFieldDefinitions = <Array<CubiqTS.CustomField>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 34: {
          /*Object encoding*/
          let val: Array<CubiqTS.BenchmarkFixing> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(34),
            streamin,
          );
          encodable.benchmarkFixings = <Array<CubiqTS.BenchmarkFixing>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 35: {
          /*Object encoding*/
          let val: Array<CubiqTS.AlgoHedgeConfigInfo> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(35),
            streamin,
          );
          encodable.algoHedgeConfigInfos = <Array<CubiqTS.AlgoHedgeConfigInfo>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 36: {
          /*Object encoding*/
          let val: Array<string> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(36),
            streamin,
          );
          encodable.tradableBranches = <Array<string>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 37: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            StaticDataProfileImplEncoder.fidTypeMap.get(37),
            streamin,
          );
          encodable.systemTradeDateRoll = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 38: {
          /*Object encoding*/
          let val: Array<CubiqTS.PlRequestOrderTypeStrategy> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(38),
            streamin,
          );
          encodable.requestOrderTypeStrategies = <Array<CubiqTS.PlRequestOrderTypeStrategy>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 39: {
          /*Object encoding*/
          let val: Array<string> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(39),
            streamin,
          );
          encodable.tradableAlgos = <Array<string>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 40: {
          /*Object encoding*/
          let val: CubiqTS.AutoHedgingStatus = this.baseEncoder.readObject(
            true,
            false,
            StaticDataProfileImplEncoder.fidTypeMap.get(40),
            streamin,
          );
          encodable.autoHedgingStatus = <CubiqTS.AutoHedgingStatus>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 41: {
          /*Object encoding*/
          let val: Array<CubiqTS.PlatformProfile> = this.baseEncoder.readObject(
            false,
            true,
            StaticDataProfileImplEncoder.fidTypeMap.get(41),
            streamin,
          );
          encodable.platformProfiles = <Array<CubiqTS.PlatformProfile>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            StaticDataProfileImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,StaticDataProfileImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return StaticDataProfileImplEncoder.fidTypeMap.has(fid);
  }
}
